import _ from 'underscore';

var factoryFn = function factoryFn(expressionLanguage) {
    var CONTEXT_DTO_TYPE = 'edge.aspects.validation.dto.ContextDTO';

    function getContextValuesForNode(currentMetadataNode) {
        var cachedContext = {};
        var compilationCtx = expressionLanguage.getCompilationContext(currentMetadataNode.xCenter);

        // Add external context values as context value expressions
        if (currentMetadataNode.externalContext) {
            _.keys(currentMetadataNode.externalContext).forEach(function (key) {
                cachedContext[key] = function () {
                    return currentMetadataNode.externalContext[key];
                };
            });
        }

        _.each(currentMetadataNode.elementMetadata.get(CONTEXT_DTO_TYPE), function (contextDefn) {
            var expFn = compilationCtx.compile(contextDefn.expression);
            cachedContext[contextDefn.name] = expFn;
        });
        return cachedContext;
    }

    var contextAspect = {
        /**
         * Add aspect properties to a view model node
         *
         * @param {Object} currentViewModelNode
         * @param {Object} currentMetadataNode
         * @param {Object} ancestorChain
         * @returns {Object}
         */
        getAspectProperties: function getAspectProperties(currentViewModelNode, currentMetadataNode, ancestorChain) {
            var ctx = getContextValuesForNode(currentMetadataNode);

            return {
                context: {
                    value: function value(name) {
                        if (ctx[name]) {
                            return ctx[name](currentViewModelNode, ancestorChain.parent);
                        }
                        return ancestorChain.parent ? ancestorChain.parent.aspects.context(name) : undefined;
                    }
                }
            };
        }
    };

    return contextAspect;
};

export default {
    'create': factoryFn
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-viewmodel-js/aspects/Context.js
// module id = 936
// module chunks = 0